export enum NumberSeparator {
  COMMA = 'comma',
  DOT = 'dot',
  WHITESPACE = 'whitespace',
  APOSTROPHE = 'apostrophe',
}

export interface CustomNumberFormat {
  get minFractionDigits(): number | undefined;
  get maxFractionDigits(): number | undefined;
  get thousandsSeparator(): NumberSeparator | undefined;
  get decimalSeparator(): NumberSeparator;
  get prefix(): string | undefined;
  get suffix(): string | undefined;
}

export type CustomNumberFormatJSON = {
  minFractionDigits: number | undefined;
  maxFractionDigits: number | undefined;
  thousandsSeparator: NumberSeparator | undefined;
  decimalSeparator: NumberSeparator;
  prefix: string | undefined;
  suffix: string | undefined;
};

export interface MutableCustomNumberFormat {
  set minFractionDigits(val: number | undefined);
  set maxFractionDigits(val: number | undefined);
  set thousandsSeparator(val: NumberSeparator | undefined);
  set decimalSeparator(val: NumberSeparator);
  set prefix(val: string | undefined);
  set suffix(val: string | undefined);
}
